export const subscription = {
  title: "Assinatura",
  description: "Gerencie sua assinatura e limites de uso",
  currentPlan: "Plano Atual",
  changePlan: "Alterar Plano",
  error: {
    loadFailed: "Falha ao carregar dados da assinatura"
  },
  status: {
    active: "Ativo",
    trial: "Trial",
    pending: "Pendente",
    past_due: "Vencida",
    canceled: "Cancelada",
    expired: "Expirada",
    exhausted: "Esgotada"
  },
  billingCycle: {
    monthly: "por mês",
    "semi-annual": "por 6 meses",
    annualy: "por ano",
    lifetime: "vitalício"
  },
  startDate: "Data de Início",
  dueDate: "Data de Vencimento",
  trialEndDate: "Fim do Trial",
  credits: {
    title: "Uso de Créditos",
    label: "Créditos",
    remaining: "restantes",
    used: "Utilizados",
    utilized: "utilizado",
    unitCosts: "Custo em Créditos por Operação",
    showInNavbar: "Exibir na Navbar",
    hideInNavbar: "Ocultar da Navbar",
    exhausted: "Créditos Esgotados",
    resourcesLimited: "Os recursos agora estão limitados até a reposição de créditos",
    warning: "Alerta de Créditos",
    limitWarning: "Você utilizou {{percentage}}% dos seus créditos. Considere fazer um upgrade."
  },
  consumption: {
    title: "Consumo do Período Atual",
    periodStart: "Período iniciado em",
    agentExecutions: "Execuções de Agentes",
    playgroundChats: "Conversas no Playground",
    embeddings: "Embeddings",
    workspaces: "Workspaces",
    // Traduções genéricas para categorias
    agents_executions: "Execuções de Agentes",
    playground_chats: "Conversas no Playground",
    knowledge_base_embeddings: "Embeddings",
    products_workspaces: "Workspaces",
    // Fallbacks para métricas individuais
    executions: "Execuções",
    chats: "Conversas"
  },
  fixedLimits: {
    title: "Limites do Plano",
    description: "Limites fixos do seu plano de assinatura",
    days: "dias"
  },
  features: {
    title: "Recursos do Plano"
  },
  restrictions: {
    title: "Restrições do Plano"
  },
  statusChanged: "Status da Assinatura Alterado",
  sse: {
    connectionError: "Erro de Conexão",
    connectionErrorDescription: "Não foi possível conectar ao servidor para atualizações em tempo real. Recarregue a página."
  }
} as const;
